import { SET_LOCALE3, LOAD_LOCALE3, LOAD_LOCALE3_SUCCESS } from "../constants";

export const setLocale3 = (locale) => {
  return {
    type: SET_LOCALE3,
    locale: locale,
  };
};

export const loadLocale3 = (locale) => {
  return {
    type: LOAD_LOCALE3,
    locale: locale,
  };
};

export const loadLocale3Success = (localeData) => {
  return {
    type: LOAD_LOCALE3_SUCCESS,
    localeData: localeData,
  };
};
